import React from "react";
import { useLocation } from "react-router-dom";
import TableTitle from "src/components/home/TableTitle";
import MoreButton from "src/components/button/MoreButton";
import MoreButton2 from "src/components/button/MoreButton2";
import SecuritiesCompanyTable from "src/components/table/SecuritiesCompanyTable";
import SwipeButton from "src/components/button/SwipeButton";
import { formatStandardDate } from "src/utils/FormatUtil";

interface SecuritiesCompanyBoardProps <T = {}> {
  contents: T[];
  date: string;
  isMore: boolean;
  handleLoadMore: () => Promise<void>;
}

const SecuritiesCompanyBoard: React.FC<SecuritiesCompanyBoardProps> = ({ contents, date, isMore, handleLoadMore }) => {
  const location = useLocation();
  return (
    <>
      <TableTitle 
      name="증권사"
      date={formatStandardDate(date)}
      modalData={{
        title: "증권사",
        content: [
        "증권사: 증권사별 운영중인 텔레그램 채널",
        "업종: 업종별 텔레그램 채널"
        ]
      }} 
      tabs={["증권사", "업종"]}
      type="/securitiescompany"
      />
      <hr className="fullscreen-hr" />
      <SwipeButton type="/securitiescompany" />
      {/* {SelectedCategory && <FilterButtons />} */}
      <SecuritiesCompanyTable
        contents={contents}
      />
      {location.pathname === "/" ? <MoreButton path="/securitiescompany" /> : isMore && <MoreButton2 onClick={handleLoadMore} />}
    </>
  );
};

export default SecuritiesCompanyBoard;




